import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import {
  Box,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from '@material-ui/core';
import thousandSeparator from '../../../utils/thousandSeparator';

function OrderProductsTable({
  order,
  page,
  setPage,
  limit,
  setLimit,
}) {
  const { user } = useSelector((s) => s.account);

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
  };

  return (
  <Card>
    <CardContent>
      <Box style={{ overflowX: 'auto' }}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>
              <Typography variant='h4'>
              Producto:
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant='h4'>
              Cantidad:
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant='h4'>
              Precio unitario:
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant='h4'>
              Subtotal:
              </Typography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {order.orderProducts.length !== 0 && order.orderProducts.map((p) => (
              <TableRow key={p.product.id}>
                <TableCell>
                  <Typography
                  variant='h5'
                  >
                    {p.product.name.toUpperCase()}
                  </Typography>
                  <Typography
                  variant='h6'
                  >
                    sku: {p.product.sku}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography
                  variant='h5'
                  >
                    {p.quantity}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography
                  variant='h5'
                  >
                    $ {thousandSeparator(p.unitPrice, '.')}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography
                  variant='h5'
                  >
                    $ {thousandSeparator(p.totalPrice, '.')}
                  </Typography>
                </TableCell>
              </TableRow>
          ))}
          {order.orderCustomPriceProducts.length !== 0
            && order.orderCustomPriceProducts.map((p, i) => (
              <TableRow key={i}>
                <TableCell>
                  <Typography
                  variant='h5'
                  >
                    {user.client.customProductName !== null ? user.client.customProductName : 'Producto extra'}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography
                  variant='h5'
                  >
                    {p.quantity}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography
                  variant='h5'
                  >
                    $ {thousandSeparator(p.unitPrice, '.')}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography
                  variant='h5'
                  >
                    $ {thousandSeparator(p.totalPrice, '.')}
                  </Typography>
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
      </Box>
      <TablePagination
        component="div"
        count={order.orderProducts && order.orderProducts.length}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleLimitChange}
        page={page}
        rowsPerPage={limit}
        rowsPerPageOptions={[5, 10, 25, 50, 100]}
        labelRowsPerPage="Filas por página"
      />
    </CardContent>
  </Card>
  );
}

OrderProductsTable.propTypes = {
  className: PropTypes.string,
  limit: PropTypes.number.isRequired,
  setLimit: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  setPage: PropTypes.func.isRequired,
  order: PropTypes.object,
};

OrderProductsTable.defaultProps = {
  order: {},
};

export default OrderProductsTable;
